import { Box, Flex, IconButton, Heading } from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
import PlayingCard from "./PlayingCard";
import "./Deck.css";

// Recreates the last completed trick using the same P1C/P2C/P3C/P4C
// classes TrickContainer uses during live play, so the cards land in the
// exact bottom/left/top/right positions they had on screen before being
// collected - not just a generic list of the cards.
const PreviousTrickOverlay = ({ trick, onClose }) => {
  const trickCards = trick.map((card) => (
    <PlayingCard
      className={`${card.details.owner}C`}
      id={card.details.owner}
      owner={card.details.owner}
      key={card.details.card}
      card={card.details.card}
      url={card.details.url}
      faceUp={card.details.faceUp}
      suit={card.suit}
      alt={card.details.card}
      shouldDarken={card.shouldDarken}
    />
  ));

  return (
    <Flex
      position="fixed"
      top="0"
      left="0"
      width="100vw"
      height="100vh"
      bg="rgba(0, 0, 0, 0.5)"
      align="center"
      justify="center"
      zIndex={20}
      onClick={onClose}
    >
      <Box
        position="relative"
        bg="white"
        borderRadius="10px"
        border="1px solid black"
        width={{ base: "80vw", md: "45vw" }}
        height={{ base: "60vh", md: "45vh" }}
        minW="280px"
        minH="280px"
        onClick={(e) => e.stopPropagation()}
      >
        <IconButton
          aria-label="Close"
          icon={<CloseIcon />}
          size="sm"
          position="absolute"
          top="10px"
          right="10px"
          zIndex={1}
          onClick={onClose}
        />
        <Heading
          position="absolute"
          top="10px"
          left="50%"
          transform="translateX(-50%)"
          size={{ base: "sm", md: "md" }}
        >
          Previous Trick
        </Heading>
        <div className="trick">{trickCards}</div>
      </Box>
    </Flex>
  );
};
export default PreviousTrickOverlay;
